import { useSelector } from 'react-redux';
import { RootState } from '../../../../core/store/store';
import { NavItem } from "../../../../core/components/NavItem";
import { Home, HomeFilled } from "../../../../core/icons/Home";
import { Messages, MessagesFilled } from "../../../../core/icons/Messages";
import { Notification, NotificationFilled } from "../../../../core/icons/Notification";
import { Profile } from "../../../../core/icons/Profile";
import { ButtonSecondary } from "../../../../core/components/Button";
import { Logout } from "../../../../core/icons/Logout";
import { ModalSimple } from "../../../../core/components/Modal";
import { useEffect, useState } from "react";
import { IconLogoutAccount } from "../../../../core/icons/LogoutAccount";
import { Settings, SettingsFilled } from "../../../../core/icons/Settings";
import useLogout from "../../../../core/hooks/useLogout";

const Header: React.FC<{ isNotification: boolean }> = ({ isNotification }) => {
  const { user } = useSelector((state: RootState) => state.onboarding);
  const { chats } = useSelector((state: RootState) => state.chat);
  const [isOpenWarning, setIsOpenWarning] = useState<boolean>(false);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const logout = useLogout();
  useEffect(() => {
    const foundUnread = chats.some(chat => chat.unread_messages > 0);
    setHasUnreadMessages(foundUnread);
  }, [chats]);

  const logoutSession = () => {
    logout();
  }

  return (
    <>
      <aside
        className="w-full bg-white p-2 md:z-10 sticky md:flex md:flex-col md:top-0 md:w-60 max-md:bottom-0 max-md:order-last max-md:rounded-t-[20px] max-md:shadow-[0_-2px_16px_rgba(0,0,0,0.08)] max-md:pb-[calc(env(safe-area-inset-bottom)+18px)] max-md:pt-3"
      >
        <img className="w-[9.5rem] m-2 max-md:hidden" src="/hookup4u-Logo-BP.png" height={96} width={250} alt="unjabbed-logo" />
        <div
          className="h-[1px] mb-2 max-md:hidden"
          style={{
            background: 'linear-gradient(to right, #FFFFFF 0%, #E50AAC 50%, #FFFFFF 100%)'
          }}
        ></div>
        <nav className="flex md:flex-col md:justify-between md:h-full">
          <ul className="flex md:flex-col max-md:w-full max-md:justify-center">
            <NavItem
              title="Discover"
              icon={<Home />}
              iconFilled={<HomeFilled />}
              href="/"
              hiddenText
            />
            <NavItem
              title="Messages"
              icon={
                <div className="relative">
                  <Messages />
                  {hasUnreadMessages  && <div className="absolute h-2 w-2 bg-primary rounded-full right-0 bottom-0.5" />}
                </div>
              }
              iconFilled={
                <div className="relative">
                  <MessagesFilled />
                  {hasUnreadMessages  && <div className="absolute h-2 w-2 bg-primary rounded-full right-0 bottom-0.5" />}
                </div>
              }
              href="/messages"
              hiddenText
            />
            <NavItem
              title="Alerts"
              icon={<Notification />}
              iconFilled={<NotificationFilled />}
              href="/notification"
              hiddenText
              />
            <NavItem
              title="Profile"
              href="/profile"
              icon={<Profile src={user?.profile_pictures?.[0]?.url || "link/image/default"} alt={user?.username} />}
              hiddenText
            />
            <NavItem
              title="Settings"
              icon={<Settings />}
              iconFilled={<SettingsFilled />}
              href="/settings"
              hiddenText
              className="max-md:hidden"
            />
          </ul>
          <ButtonSecondary
            title="Logout"
            icon={<Logout />}
            className="max-md:hidden w-full mb-2"
            onClick={() => { setIsOpenWarning(true) }}
          />
        </nav>
      </aside>
      <ModalSimple
        title="Logout"
        variant="secondary"
        actionExecuted={isOpenWarning}
        onClose={() => { setIsOpenWarning(false) }}
        onAction={logoutSession}
        icon={<IconLogoutAccount />}
      >
        Are you sure do you want to logout your account?
      </ModalSimple>
    </>
  );
};

export default Header;
